import { ssData } from "data/ss-store";
import { removeAllCookies, resetAnalytics, trackEvent } from "utils";

type RedirectCallback<T> = (destination: string) => T;
const defaultRedirect: RedirectCallback<void> = (destination: string) => {
  window.location.href = destination;
  return;
};

/**
 * Logout user and redirect to homepage.
 *
 * @param returnTo - an optional destination to return to if the user logs in
 * @param redirect - an optional redirect function
 */
export function logout<T>(returnTo?: string, redirect?: RedirectCallback<T>): T;
export function logout(returnTo?: string, redirect = defaultRedirect) {
  trackEvent("Log Out");
  resetAnalytics();
  removeAllCookies();
  const query = returnTo ? `?to=${encodeURIComponent(returnTo)}` : "";
  const destination = `/auth/logout${query}`;
  return redirect(destination);
}

export function isLoggedIn() {
  return !!ssData.user;
}

export function authUser() {
  return ssData.user;
}

/**
 * Adds headers to requests to backend. Mostly acts as a bridge between old
 * system and Universal Login.
 *
 * Does nothing if legacy auth. If universal adds token and custom headers so
 * proxy knows to pass the request through to keystone.
 *
 * @param base - headers object to extend
 * @param throughProxy - set to false if request is going directly to keystone-api
 * @returns
 */
export function authHeaders(
  base: Record<string, string> = {},
  throughProxy = true
) {
  const headers = base;
  if (ssData.user?.token) {
    headers.Authorization = `Bearer ${ssData.user.token}`;
  }
  if (throughProxy) {
    headers["x-universal-login"] = "?1";
    if (ssData.user) {
      headers["x-username"] = ssData.user.email;
    }
  }
  return headers;
}
